/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React, {
  useContext, useState, useRef, useEffect,
} from 'react';
import propTypes from 'prop-types';
import { ArcButton } from '@aidesign/aid-base';
import { useTranslation } from 'react-i18next';
import { AppContext } from '@/redux/store';
import { getReducedGoods, getReduceGoodsTipsAfterChangeSize } from '@/utils/rules/changeSizeR';
import ConfirmMask from '@/components/ConfirmMask/confirmMask';
import callEngine from '@/3DEngine/callEngine/index';
import { GIO } from '@/utils/gio';
import {
  cabinetShape, cabinetType1, HighCabinetId,
} from '@/utils/rules/const';
// import Loading from '@/components/Loading/loading';
// import { getdesignCode } from '@/apis/offer';

import homeStyle from './Home.module.scss';

// import SizeData from '../../components/sizeData/SizeData';
import SizeSelection from '../../components/sizeData/SizeSelection';

function Home(props) {
  const { t } = useTranslation();
  const { dispatch, initState } = useContext(AppContext);
  const cRef = useRef(null);
  const [isShowScreenMask, setIsShowScreenMask] = useState(false);
  const {
    arrowShow, stepList, ispackOffer, isChangeApi, Modify,
  } = initState;
  // const [slinkWidth, setSlinkWidth] = useState('');
  // const [canelBasket, setCanselBasket] = useState('');
  // const [sinkLocation, setSlinkLocation] = useState('');

  const [stepProgress, setStepProgress] = useState(33); // 步骤百分比
  const [stepWhich, setStepWhich] = useState(1); // 步骤
  const [changeGoodsTips, setChangeGoodsTips] = useState('');
  const [designCode, setdesignCode] = useState('');

  useEffect(() => { // 页面DOM渲染后设置isJump，表示页面跳转并DOM渲染完成
    dispatch({ type: 'isJump', payload: true });
    setdesignCode(localStorage.getItem('designCode'));
  }, []);

  // 3105AB测试 B方案     选择A方案的时候删除下面的useEffect
  // useEffect(() => {
  //   if (localStorage.getItem('storageUser') === 'BUser') {
  //     dispatch({
  //       type: 'setTitleList',
  //       payload: [
  //         {
  //           title: '1/5柜型尺寸选择',
  //           path: '/home/homepage/stepone',
  //         },
  //         {
  //           title: '1/5柜型尺寸选择',
  //           path: '/home/homepage/steptwo',
  //         },
  //         {
  //           title: '1/5柜型尺寸选择',
  //           path: '/home/homepage/stepthree',
  //         },
  //         {
  //           title: '2/5门板选择',
  //           path: '/home/doorPlank',
  //         },
  //         {
  //           title: '3/5台面选择',
  //           path: '/home/mesa',
  //         },

  //         {
  //           title: '4/5内配储物',
  //           path: '/home/storage/recommendStorage',
  //         },
  //         {
  //           title: '4/5内配储物',
  //           path: '/home/storage/drawer',
  //         },
  //         {
  //           title: '4/5内配储物',
  //           path: '/home/storage/basket',
  //         },
  //         {
  //           title: '4/5内配储物',
  //           path: '/home/storage/sink',
  //         },
  //         {
  //           title: '4/5内配储物',
  //           path: '/home/storage/faucet',
  //         },
  //         {
  //           title: '4/5内配储物',
  //           path: '/home/storage/tallark',
  //         },
  //         {
  //           title: '4/5内配储物',
  //           path: '/home/storage/hand',
  //         },
  //         {
  //           title: '5/5厨房设计报价',
  //           path: '/home/offer',
  //         },
  //       ],
  //     });

  //     dispatch({
  //       type: 'setTabList',
  //       payload: [
  //         // 内配tab
  //         {
  //           navName: '储物收纳',
  //           key: 'first',
  //           url: 'recommendStorage',
  //         },
  //         {
  //           navName: '水槽',
  //           key: 'second',
  //           url: 'sink',
  //         },
  //         {
  //           navName: '水龙头',
  //           key: 'third',
  //           url: 'faucet',
  //         },
  //         {
  //           navName: '把手',
  //           key: 'fourth',
  //           url: 'hand',
  //         },
  //       ],
  //     });
  //   }
  // }, []);

  const routeAction = (path) => {
    props.history.push(path);
    dispatch({ type: 'switch-nav', payload: t('step_2_title') });
    // dispatch({ type: 'json-template', payload: Template });
  };
  const publicGoback = () => {
    dispatch({ type: 'backFromSize', payload: false }); // 修改判断是确定还是返回
    dispatch({ type: 'oldTempleteJson', payload: {} }); // 清空存放更改时候第一次的templete
    localStorage.removeItem('designCode'); // 清空designcode缓存
    if (ispackOffer) {
      dispatch({ type: 'ispackOffer', payload: false });
      props.history.push(`/home/packOffer/${designCode}`);
    } else {
      props.history.push('/home/offer');
    }
    dispatch({ type: 'isTempleteSave', payload: true }); // save接口判断为true
    // dispatch({ type: 'arrow-show', payload: true }); // 返回将返回表示设置为true
    dispatch({ type: 'switch-nav', payload: t('step_5_title') }); // currentTitle设置为'5/5厨房设计报价'
    dispatch({
      type: 'json-template',
      payload: Object.keys(initState.TemporaryJson).length === 0
        ? initState.jsonTemplate : initState.TemporaryJson,
    }); // 提交时存入TEMPLETE-JSON
  };
  // 返回到报价页面
  const goBack = () => {
    // 修改尺寸返回尺寸页面的保存;
    const tipsInfoArr = getReduceGoodsTipsAfterChangeSize(getReducedGoods({
      oldTemp: Object.keys(initState.oldTempleteJson).length === 0 ? initState.jsonTemplate : initState.oldTempleteJson,
      newTemp: Object.keys(initState.TemporaryJson).length === 0 ? initState.jsonTemplate : initState.TemporaryJson,
    }), t);
    if (tipsInfoArr.length !== 0) {
      setIsShowScreenMask(true);
      setChangeGoodsTips(tipsInfoArr);
    } else {
      publicGoback();
    }
  };
  const closeResetMask = () => {
    setIsShowScreenMask(false);
    publicGoback();
  };
  const cancelResetMask = () => {
    setIsShowScreenMask(false);
  };
  const { history: { location: { pathname } } } = props;
  // 点击下一步按钮
  const handleBtnRouter = async () => {
    if (!arrowShow && pathname.includes('stepthree')) {
      callEngine(initState.engine3D, 'room', true, undefined).then(() => {
        setTimeout(() => {
          goBack();
        }, 200);
      }); // 显示墙面地面窗户
    } else {
      // 更改报价页，且切换了柜型调用action
      // if (pathname.includes('stepone') && !(!arrowShow && !isChangeApi)) {
      // debugger;
      const {
        isSeat, sizeTop, lengthTopVal, isHighlowCabinet, refrigerId,
      } = initState;
      if (pathname.includes('stepone') && !(Modify ? (!Modify || !isChangeApi) : (Modify && !isChangeApi))) {
        const {
          typeI, typeH, typeL,
        } = cabinetShape;
        const topLenParameter = (type, lens) => {
          if (type === typeI) {
            if (isSeat === 'R') {
              return {
                len1: lens[0] ? lens[0] : lens[1],
              };
            }
            if (isSeat === 'M') {
              return {
                len2: lens[1] ? lens[1] : lens.filter((n) => n)[0],
              };
            }
            if (isSeat === 'L') {
              if (initState.sizeUnder.key === 'L') {
                return { len2: lens[0] };
              }
              return { len3: lens.filter((n) => n)[0] };
            }
          }
          if (type === typeH) {
            return {
              len1: lens[0],
              len3: lens[1] ? lens[1] : lens[2],
            };
          }
          if (isSeat === 'R') {
            return {
              len1: lens[0],
              len2: lens[1],
            };
          }
          if (isSeat === 'L') {
            return {
              len2: lens[1],
              len3: lens[2] ? lens[2] : lens[0],
            };
          }
          return {};
        };
        GIO('clickData', {
          eventType_var: 'click',
          module_var: 'footer_tab',
          objectName_var: '下一步',
          attributeName1_var: '是否修改顶柜位置',
          attributeValue1_var: topLenParameter(sizeTop.key, lengthTopVal).len2 ? '是' : '否',
        });
        await dispatch({ type: 'showInitLoading', payload: true });
        cRef.current.Apiaction(); // init/update
      } else if (pathname.includes('steptwo')) {
        GIO('clickData', {
          eventType_var: 'click',
          module_var: 'footer_tab',
          objectName_var: '下一步',
          attributeName1_var: '是否高低台面',
          attributeValue1_var: isHighlowCabinet ? '是' : '否',
        });
      } else if (pathname.includes('stepthree')) {
        GIO('clickData', {
          eventType_var: 'click',
          module_var: 'footer_tab',
          objectName_var: '下一步',
          attributeName1_var: '是否要冰箱',
          attributeValue1_var: refrigerId !== 0 ? '是' : '否',
        });
      }
      Object.keys(stepList).forEach((key) => {
        if (pathname.includes(stepList[key].path)) {
          props.history.push(
            (stepList[+key + 1] ? stepList[+key + 1].path : '/home/doorPlank')
            + (pathname.includes('change') ? '/change' : ''),
          );
        }
      });
    }
  };

  // 步骤title
  const stepTitle = stepList.find((item) => pathname.includes(item.path));

  // 进度条百分比/Apiaction
  useEffect(() => {
    setTimeout(() => {
      dispatch({ type: 'isJump', payload: true });
    }, 100);
    if (pathname.includes('stepone')) {
      setStepProgress(33);
      setStepWhich(1);
    } else if (pathname.includes('steptwo')) {
      setStepProgress(66);
      setStepWhich(2);
    } else {
      setStepProgress(100);
      setStepWhich(3);
    }
  }, [pathname]);
  return (
    <div className={homeStyle.content}>
      {/* <RenderBox width={375} height={250} templeteJson={templatejson} /> */}
      <SizeSelection ref={cRef} />
      {/* {
        arrowShow ? (
          <div className={homeStyle['btn-center']} role="none" onClick={() => routeAction('/home/doorPlank')}>
            <ArcButton
              style={{
                backgroundColor: '#111', width: '20.875', height: '3.125',
              }}
              text={t('size_data.next_btn')}
            />
          </div>
        ) : (
          <div className={homeStyle['btn-center']} role="none" onClick={() => goBack()}>
            <ArcButton
              style={{
                backgroundColor: '#111', width: '20.875', height: '3.125',
              }}
              text={t('size_data.determine')}
            />
          </div>
        )
      } */}

      <div
        className={homeStyle['footer-content']}
        // steptwo时absolute避免手机唤起键盘之后，fixed布局对应的视窗变成了键盘以上的部分
        style={{ position: pathname.includes('/stepone') ? 'fixed' : 'absolute' }}
      >
        <div className={homeStyle['article-steps']}>
          <div className={homeStyle['step-text']}>
            {t('step')}
            {' '}
            {stepWhich}
            /3
            {' '}
            {stepTitle?.title}
          </div>
          <div className={homeStyle.container}>
            <div className={`${homeStyle.skills} ${homeStyle.css}`} style={{ width: `${stepProgress}%` }} />
          </div>
        </div>
        <div
          className={homeStyle['next-btn']}
          role="none"
          onClick={() => handleBtnRouter(props)}
        >
          {
             !arrowShow && (pathname === '/home/homepage/stepthree/change' || pathname === '/home/homepage/stepthree')
               ? t('size_data.determine') : t('next_step')
          }
        </div>


      </div>

      { // 修改信息提示弹窗
        isShowScreenMask ? (
          <ConfirmMask
            title={t('change_size.warm_prompt')}
            changeGoodsTips={changeGoodsTips}
            bgColor
          // text={`${slinkWidth} + ${canelBasket} + ${sinkLocation}`}
            btn1={t('size_data.i_think')}
            btn2={t('size_data.determine')}
            confirmMask={isShowScreenMask}
            firstBtnClick={cancelResetMask}
            secondBtnClick={closeResetMask}
          />
        ) : null
      }

    </div>
  );
}

Home.propTypes = {
  history: propTypes.shape({
    go: propTypes.func,
    push: propTypes.func,
    goBack: propTypes.func,
    replace: propTypes.func,
    location: propTypes.shape({
      pathname: propTypes.string,
    }),
  }).isRequired,
};
export default Home;
